<header class="app-header navbar navbar-expand-lg px-3 shadow-sm">
  <div class="container-fluid d-flex align-items-center gap-2">

    <!-- 🔰 Branding -->
    <a class="navbar-brand d-flex align-items-center" routerLink="/dashboard">
      <img src="MUEBA-sombra.png" alt="MUEBA" class="logo-img" />
    </a>

    <!-- ☰ Mobile toggler -->
    <button class="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMain"
      aria-controls="navbarMain" aria-expanded="false" aria-label="Abrir menú">
      <i class="bi bi-list mobile-toggle-icon"></i>
    </button>

    <div class="navbar-collapse collapse" id="navbarMain">

      <!-- ══════════════ Navegación principal ══════════════
           Los módulos van directos, no escondidos en desplegables:
           sólo se agrupa lo que de verdad tiene varias entradas. -->
      <ul class="navbar-nav main-nav me-auto">

        <li class="nav-item">
          <a routerLink="/dashboard" routerLinkActive="active" (click)="closeNavbar()" class="nav-link">
            <i class="bi bi-speedometer2"></i>
            <span>Panel</span>
          </a>
        </li>

        @if (tieneBalance()) {
          <li class="nav-item">
            <a routerLink="/produccion-grupo" routerLinkActive="active" (click)="closeNavbar()" class="nav-link">
              <i class="bi bi-diagram-3"></i>
              <span>Balance<span class="nav-label-long"> hidráulico</span></span>
            </a>
          </li>
        }

        @if (tieneCalidad()) {
          <li class="nav-item">
            <a routerLink="/calidad-aplicacion" routerLinkActive="active" (click)="closeNavbar()" class="nav-link">
              <i class="bi bi-droplet-half"></i>
              <span>Calidad<span class="nav-label-long"> del agua</span></span>
            </a>
          </li>
        }

        <li class="nav-item dropdown" routerLinkActive="nav-item--active">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-file-earmark-text"></i>
            <span>Reportes</span>
          </a>

          <ul class="dropdown-menu dropdown-card">
            <li>
              <a routerLink="/reportes/lecturas" routerLinkActive="active" (click)="closeNavbar()"
                class="dropdown-item d-flex align-items-center gap-2">
                <i class="bi bi-droplet-half fs-5 text-primary"></i>
                <span>Historial de lecturas</span>
              </a>
            </li>

            @if (userPermissionsSignal().includes('visualizar_titulos_concesion')) {
              <li>
                <a routerLink="/reportes/consumo-trimestral" routerLinkActive="active" (click)="closeNavbar()"
                  class="dropdown-item d-flex align-items-center gap-2">
                  <i class="bi bi-file-earmark-bar-graph fs-5 text-primary"></i>
                  <span>Consumo trimestral</span>
                </a>
              </li>
            }
          </ul>
        </li>

        @if (userPermissionsSignal().includes('visualizar_titulos_concesion') || userPermissionsSignal().includes('crear_titulo_concesion')) {
          <li class="nav-item dropdown" routerLinkActive="nav-item--active">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="bi bi-file-earmark-lock"></i>
              <span>Concesiones</span>
            </a>

            <ul class="dropdown-menu dropdown-card">
              @if (userPermissionsSignal().includes('visualizar_titulos_concesion')) {
                <li>
                  <a routerLink="/concesiones" routerLinkActive="active" (click)="closeNavbar()"
                    class="dropdown-item d-flex align-items-center gap-2">
                    <i class="bi bi-folder2-open fs-5 text-secondary"></i>
                    <span>Ver títulos</span>
                  </a>
                </li>
              }

              @if (userPermissionsSignal().includes('crear_titulo_concesion')) {
                <li>
                  <a routerLink="/concesiones/nuevo" routerLinkActive="active" (click)="closeNavbar()"
                    class="dropdown-item d-flex align-items-center gap-2">
                    <i class="bi bi-file-earmark-plus fs-5 text-primary"></i>
                    <span>Agregar título</span>
                  </a>
                </li>
              }
            </ul>
          </li>
        }
      </ul>

      <!-- ══════════════ Controles ══════════════ -->
      <div class="navbar-right">

        <!-- 🔁 Vista: sólo iconos en escritorio, con etiqueta en móvil -->
        <div class="btn-group vista-toggle" role="group" aria-label="Cambiar vista">
          <button type="button" class="btn" [class.active]="!isMapView()" (click)="switchView(false)"
            title="Vista de tarjetas" aria-label="Vista de tarjetas">
            <i class="bi bi-ui-checks-grid"></i>
            <span class="vista-label">Tarjetas</span>
          </button>

          <button type="button" class="btn" [class.active]="isMapView()" (click)="switchView(true)"
            title="Vista de mapa" aria-label="Vista de mapa">
            <i class="bi bi-map-fill"></i>
            <span class="vista-label">Mapa</span>
          </button>
        </div>

        <!-- ⚙️ Administración: configuración, no un módulo de operación,
             por eso va con los controles y no en la navegación principal.
             Cada entrada aparece según su propio permiso: administrar los
             accesos de la gente y dar de alta clientes son capacidades
             distintas y no siempre van juntas. -->
        @if (puedeAdministrar()) {
          <a routerLink="/administracion" routerLinkActive="active"
             (click)="closeNavbar()" class="btn control-btn" title="Administración"
             aria-label="Administración">
            <i class="bi bi-gear-fill"></i>
            <span class="vista-label">Administración</span>
          </a>
        }

        <!-- 🔔 Notificaciones -->
        <div class="position-relative noti-wrap">
          <button type="button" class="btn notificaciones-btn" (click)="toggleDropdown()"
            [attr.aria-label]="'Notificaciones (' + totalNotificaciones() + ')'">
            <i class="bi bi-bell-fill"></i>
            <span class="vista-label">Notificaciones</span>

            @if (totalNotificaciones() > 0) {
              <span class="badge bg-danger rounded-pill noti-badge">{{ totalNotificaciones() }}</span>
            }
          </button>

          @if (dropdownVisible()) {
            <div class="dropdown-notificaciones shadow rounded bg-white">

              @if (notificacionesAlarmasSafe().length > 0) {
                <div class="dropdown-section-title alarmas">
                  <i class="bi bi-exclamation-triangle-fill me-1"></i> Alarmas
                </div>

                <ul class="list-group list-group-flush">
                  @for (n of notificacionesAlarmasSafe(); track n.iId) {
                    <li class="list-group-item list-group-item-action alarma-item" (click)="irANotificacionAlarma(n)">
                      <div class="fw-semibold text-danger">{{ n.tipoAlarma }}</div>
                      <div class="small text-secondary">{{ n.application_name }}</div>
                      <div class="small text-muted">{{ n.dtFechaAlarma | tiempoRelativo }}</div>
                    </li>
                  }
                </ul>
              }

              @if (comentariosNoVistosSafe().length > 0) {
                <div class="dropdown-section-title comentarios">
                  <i class="bi bi-chat-left-text-fill me-1"></i> Comentarios
                </div>

                <ul class="list-group list-group-flush">
                  @for (c of comentariosNoVistosSafe(); track c.iIdComentario) {
                    <li class="list-group-item list-group-item-action" (click)="irADetalleAlarma(c)">
                      <div class="fw-semibold">Alarma #{{ c.iIdAlarma }}</div>
                      <div class="small text-muted">{{ c.dtFechaComentario | date:'short' }}</div>
                      <div class="small text-secondary">Por: {{ c.cAutor }}</div>
                      <div class="mt-1">
                        {{ c.cComentario.length > 75 ? (c.cComentario | slice:0:75) + '...' : c.cComentario }}
                      </div>
                    </li>
                  }
                </ul>
              }

              @if (notificacionesAlarmasSafe().length === 0 && comentariosNoVistosSafe().length === 0) {
                <div class="px-3 py-3 text-muted small text-center">No hay notificaciones nuevas</div>
              }
            </div>
          }
        </div>

        <!-- 🏢 Universo activo · PASO 16
             Se lista el UNIVERSO, no el cliente: ASUR son 9 aeropuertos pero
             un solo lugar donde trabajar, y desde que el backend consolida los
             nueve mostraban lo mismo. -->
        @if (universoActivo(); as universo) {
          @if (tieneMultiplesUniversos()) {
            <div class="dropdown cliente-selector">
              <button class="btn cliente-chip dropdown-toggle" type="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="bi bi-buildings"></i>
                <span class="cliente-nombre">{{ universo.nombre }}</span>
              </button>

              <ul class="dropdown-menu dropdown-menu-end dropdown-card cliente-selector__menu">
                <li class="cliente-selector__head"><h6 class="dropdown-header">Cambiar de cliente</h6></li>

                @for (u of universos(); track u.clave) {
                  <li>
                    <button type="button" class="dropdown-item d-flex align-items-center gap-2"
                      [class.active]="u.clave === universo.clave"
                      (click)="cambiarCliente(u.representante.iIdCliente)">
                      <i class="bi" [class.bi-check-circle-fill]="u.clave === universo.clave"
                        [class.bi-circle]="u.clave !== universo.clave"></i>
                      <span>{{ u.nombre }}</span>
                      @if (u.clientes.length > 1) {
                        <span class="badge rounded-pill text-bg-light ms-auto">{{ u.clientes.length }}</span>
                      }
                    </button>
                  </li>
                }
              </ul>
            </div>
          } @else {
            <div class="cliente-chip cliente-chip--estatico">
              <i class="bi bi-buildings"></i>
              <span class="cliente-nombre">{{ universo.nombre }}</span>
            </div>
          }
        }

        <!-- 👤 Usuario: nombre, rol y salir en un solo control -->
        <div class="dropdown user-menu">
          <button class="btn user-trigger dropdown-toggle" type="button" data-bs-toggle="dropdown"
            aria-expanded="false" [attr.aria-label]="'Menú de ' + userFullName()">
            <span class="avatar">{{ iniciales() }}</span>
            <span class="user-trigger__name">{{ userFullName() }}</span>
          </button>

          <ul class="dropdown-menu dropdown-menu-end dropdown-card user-menu__panel">
            <li class="user-menu__head">
              <span class="avatar avatar--lg">{{ iniciales() }}</span>
              <div class="user-menu__id">
                <div class="user-menu__name">{{ userFullName() }}</div>
                @if (userRole()) {
                  <div class="user-menu__role text-capitalize">{{ userRole() }}</div>
                }
              </div>
            </li>

            <li><hr class="dropdown-divider" /></li>

            <li>
              <button type="button" class="dropdown-item dropdown-item--danger d-flex align-items-center gap-2"
                (click)="cerrarSesion()">
                <i class="bi bi-box-arrow-right fs-5"></i>
                <span>Cerrar sesión</span>
              </button>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</header>
